import React from "react";
import { FormControl, Input, Button, IconButton, Banner, Container  } from "@airbus/components-react";
import {Visibility, VisibilityOff} from '@airbus/icons/react';



//MODELS IMPORT
import GlobalUser from "../models/User";//get global instance


//EVENT BUS
import eventBus from "../eventBus/EventBus";



/**
 * LOGIN FORM
 * props : None
 */




class LoginForm extends React.Component {
    
    
    constructor(){
        super();

        //states
        this.state={
            showPassword: false,
            form:{
                username: '',
                password: ''
            },
            notification: false,     //notification display
            windowWidth: window.innerWidth,     //screen width 
            windowHeight: window.innerHeight,   //screen height
        }
       
        
    }


    componentDidUpdate = () => {
      
        window.addEventListener("resize", this.handleResize);
    }

    /*Handle screen size*/
    handleResize = (e) => {
      
        //debugger;
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    
    };



    /**
     * RENDERING
     * @returns dom
     */
    render() {

        return(
            
             <Container until="sm">   
                
            
             {/* Notification*/}
             {this.state.notification ?
                <div style={{zIndex:1000, position:"sticky", top:0}}>
                <Banner style={{display:this.state.notification}} variant={this.notifVariant} autoHideDuration={3000}  onClose={() => this.toggleNotif(false)}>
                    <div>
                    <p>{this.notifMessage}</p>
                    {this.notifDescription !== null ?
                    <p>{this.notifDescription}</p>
                    :null}
                    </div>
                </Banner>
                <p></p>
                </div>
            :null}
            

            <form>
                
                {/* Username */}

                <FormControl
                    error={!this.usernameValid()}
                    errorText="Obligatoire"
                    label="Utilisateur"
                    placeholder="Utilisateur"
                    required
                >
                    <Input value={this.state.form.username} onChange={this.onChangeUsername} />
                </FormControl>

                {/* Password */}

                <FormControl
                    error={!this.passwordValid()}
                    errorText="Obligatoire"
                    label="Mot de Passe"
                    placeholder="Mot de Passe"
                    required
                >
                    <Input value={this.state.form.password} 
                            type={this.state.showPassword ? "text" : "password"}
                            onChange={this.onChangePassword} 
                            endAdornment={
                                <IconButton variant="ghost" size="small" onClick={() => this.setState({showPassword:!this.state.showPassword})}>
                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            }
                    />
                </FormControl>
                
                {/* Submit */}
                </form>
                <Button variant="primary" 
                        onClick = {this.onSubmit}
                        disabled = {!this.usernameValid() || !this.passwordValid()}
                        style={{
                            width: "100%"
                            }}>
                        SE CONNECTER
                </Button>
                
                
            


            </Container>

        );

      
    }

    /**
    * FUNCTIONS
    */

    //Vérification Username
    usernameValid = () => {
        return this.state.form.username !== undefined && this.state.form.username.length > 0;
    };

    //Check Password
    passwordValid = () => {
        return this.state.form.password !== undefined && this.state.form.password.length > 0;
    };

    
    /**
    * EVENTS
    */
    //USERNAME Input Change handler
     onChangeUsername = (event) => {
         
        let formData = this.state.form;
        formData.username = event.target.value;
        
        this.setState({form:formData});
         
     }

     //PASSWORD Input Change handler
     onChangePassword = (event) => {
         
        let formData = this.state.form;
        formData.password = event.target.value;
        
        this.setState({form:formData});
         
     }

    //Submit Login & Password
    onSubmit = async (event) =>  {

        let user = await GlobalUser.logIn(this.state.form.username, this.state.form.password);

        //API call error
        if (user === undefined){
            //Fire notification
            this.notifVariant = "error";
            this.notifMessage = "API erreur: Authentification impossible";
            this.notifDescription = null;
            this.toggleNotif(true);
        }
        //Erreur authentification
        else if (user.getUserId() === null){
            
            
            //Fire notification
            this.notifVariant = "error";
            this.notifMessage = "Authentification échouée";
            this.notifDescription = user.getResponse().response+": "+user.getResponse().responseDescription;
            this.toggleNotif(true);

           
            
        }else{
        //Authentification OK

            //Export to event Bus for main component state refresh
            eventBus.dispatch("user", { user: user });
        }

    }

    //fire / close notification
    toggleNotif(val) {
        this.setState({
            notification: val
        });
      }

    
   


}


  

export default LoginForm;